import React, { useRef, useEffect } from 'react';

function IsochronousShape({ vertices, color, height, width }) {
	const canvasRef = useRef(null);
	const drawPolygon = React.useCallback(
		(ctx) => {
			let minX;
			let minY;
			let maxX;
			let maxY;
			ctx.clearRect(0, 0, canvasRef.current.width, canvasRef.current.height);
			ctx.fillStyle = '#ffffff0f';
			ctx.fill();
			vertices.forEach((vertex, i) => {
				if (i === 0) {
					// if first point
					minX = maxX = vertex.lng;
					minY = maxY = vertex.lat;
				} else {
					minX = Math.min(vertex.lng, minX);
					minY = Math.min(vertex.lat, minY);
					maxX = Math.max(vertex.lng, maxX);
					maxY = Math.max(vertex.lat, maxY);
				}
			});
			// now get the map width and heigth in its local coords
			const mapWidth = maxX - minX;
			const mapHeight = maxY - minY;
			const mapCenterX = (maxX + minX) / 2;
			const mapCenterY = (maxY + minY) / 2;
			// to find the scale that will fit the canvas get the min scale to fit height or width
			const scale = Math.min(canvasRef.current.width / mapWidth, canvasRef.current.height / mapHeight);
			vertices.forEach((vertex) => {
				ctx.lineTo(
					(vertex.lng - mapCenterX) * scale + canvasRef.current.width / 2,
					(mapCenterY - vertex.lat) * scale + canvasRef.current.height / 2
				);
			});
			ctx.fillStyle = color;
			ctx.fill();
		},
		[vertices]
	);
	const drawCircle = React.useCallback(
		(ctx) => {
			const centerX = canvasRef.current.width / 2;
			const centerY = canvasRef.current.height / 2;
			const radius = 70;
			ctx.beginPath();
			ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI);
			ctx.fillStyle = color;
			ctx.fill();
			ctx.closePath();
		},
		[vertices]
	);
	useEffect(() => {
		const canvas = canvasRef.current;
		const context = canvas.getContext('2d');
		if (vertices && vertices.length > 0) {
			// Our draw come here
			drawPolygon(context);
		} else drawCircle(context);
	}, [drawPolygon, drawCircle]);
	return <canvas ref={canvasRef} style={{ width: width || '100px' }} />;
}
export default IsochronousShape;
